import React from 'react'
import { useState } from 'react';
import axios from 'axios'

const LoginForm = () => {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState('')

    const handleSubmit = async (e) => {
        e.preventDefault();

        const authObject = { 'Project-ID': 'accc9c07-82ed-4a06-bcc3-525739d10a8e', 'User-Name': username, 'User-Secret': password}

        // asynchronus API call to chatengine
        try {
            // check if username/pass exists
            // log in if so
            await axios.get('https://api.chatengine.io/chats', { headers: authObject })

            // store login in local storage
            localStorage.setItem('username', username)
            localStorage.setItem('password', password)

            window.location.reload();
        } catch (error) {
            // error if not, try with a new username!
            setError('Invalid Login!!!')
            
        }
    }

    return (
    <div className="wrapper">
      <div className="form">
        <h1 className="title">ChatPSU</h1>
        <img className = "title" src="https://upload.wikimedia.org/wikipedia/en/thumb/3/3a/Penn_State_Nittany_Lions_logo.svg/1200px-Penn_State_Nittany_Lions_logo.svg.png" alt="PSU Logo"/>
        <form onSubmit={handleSubmit}>
          <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className="input" placeholder="Username" required />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input" placeholder="Password" required />
          <div align="center">
            <button type="submit" className="button">
              <span>Start chatting</span>
            </button>
          </div>
          <h2 className="title">{error}</h2>
        </form>
      </div>
    </div>
    )
}

export default LoginForm;